import React, { useEffect } from "react";

/**
 * @py-component internal use only
 * Component that handles scrolling to field when there are errors
 */
const ErrorScroll = ({
	children,
	id,
	hasErrors,
	disabled = false,
}: {
	children: React.ReactNode;
	id: string;
	hasErrors: boolean;
	disabled?: boolean;
}) => {
	useEffect(() => {
		if (hasErrors && !disabled) {
			// Add a small delay to ensure DOM is stable from any enter/exit animations
			setTimeout(() => {
				const fieldElement = document.getElementById(id);
				if (fieldElement) {
					// Use requestAnimationFrame to ensure smooth scrolling
					requestAnimationFrame(() => {
						// Prevent any potential event bubbling
						const scrollHandler = (e: Event) => {
							e.stopPropagation();
						};

						fieldElement.addEventListener("scroll", scrollHandler, { passive: false });

						fieldElement.scrollIntoView({
							behavior: "smooth",
							block: "center",
						});

						// Clean up the event listener
						setTimeout(() => {
							fieldElement.removeEventListener("scroll", scrollHandler);
						}, 20);
					});
				}
			}, 10);
		}
	}, [hasErrors, disabled, id]);

	return <>{children}</>;
};

export default ErrorScroll;
